import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Field, Input, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { Controller } from 'react-hook-form';
import CurrencyCodeDropdown from '../../../common/formFields/CurrencyCodeDropdown';
import ITaxDividendFormProps from './ITaxDividendFormProps';

const TaxDividendForm = ({ taxDividends, form, companyId }: ITaxDividendFormProps): JSX.Element => {
  const { control, errors, setValue } = form;
  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 5 }}>
        <Stack horizontal tokens={{ childrenGap: 5 }}>
          <Controller
            name="taxProposedDividendAmount"
            control={control}
            defaultValue={taxDividends.taxProposedDividendAmount}
            rules={{
              min: {
                value: 0,
                message: 'Tax Proposed Dividend Amount cannot be less than zero',
              },
              max: {
                value: 99999999999999,
                message:
                  'Tax Proposed Dividend Amount cannot be that larger than 99,999,999,999,999',
              },
              required: 'Please provide a Tax Proposed Dividend Amount',
            }}
            render={({ onChange, onBlur, value, name, ref }): React.ReactElement => (
              <Field
                label="Tax Proposed Dividend Amount"
                required
                style={{ width: '295px' }}
                validationMessage={errors?.taxProposedDividendAmount?.message as string}
              >
                <Input
                  id="taxProposedDividendAmount"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  name={name}
                  ref={ref}
                  type="number"
                  min={0}
                />
              </Field>
            )}
          />
          <Controller
            name="taxCurrencyCode"
            control={control}
            render={() => (
              <CurrencyCodeDropdown
                propertyName="taxCurrencyCode"
                useDefaultCurrenciesForCompanyId={companyId}
                required
                defaultValue={taxDividends.taxCurrencyCode}
                errorMessage={errors?.taxCurrencyCode?.message}
                handleChange={(newValue: string, valueKey: string): void => {
                  setValue('taxCurrencyCode', newValue);
                }}
              />
            )}
            defaultValue={taxDividends.taxCurrencyCode}
            rules={{
              required: 'Please provide a Currency Code',
            }}
            required
          />
        </Stack>
        <Controller
          name="taxComments"
          control={control}
          defaultValue={taxDividends.taxComments || ''}
          render={({ onChange, onBlur, value, name, ref }): React.ReactElement => (
            <Field label="Comments" validationMessage={errors?.taxComments?.message as string}>
              <Input
                id="taxComments"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                ref={ref}
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default TaxDividendForm;
